"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trigger = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));

var tip_1 = require("./tip");

exports.Trigger = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  &:focus-within + ", ".enabled, ", ".enabled:focus-within {\n    height: auto;\n    pointer-events: all;\n    width: max-content;\n  }\n\n  &:hover + ", ".enabled, ", ".enabled:hover {\n    height: auto;\n    pointer-events: all;\n    width: max-content;\n  }\n"], ["\n  &:focus-within + ", ".enabled, ", ".enabled:focus-within {\n    height: auto;\n    pointer-events: all;\n    width: max-content;\n  }\n\n  &:hover + ", ".enabled, ", ".enabled:hover {\n    height: auto;\n    pointer-events: all;\n    width: max-content;\n  }\n"])), tip_1.Tip, tip_1.Tip, tip_1.Tip, tip_1.Tip);
var templateObject_1;